// extracted by mini-css-extract-plugin
export default {"blogOverview":"blogoverview_blogOverview__oFxJY","button":"blogoverview_button__HzUA7"};